module.exports = __webpack_public_path__ + "app/assets/images/man7-df40f461fab34a29c2a45591f3123b2e.jpg";